import { useState } from "react";
import axios from "axios";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [sending, setSending] = useState(false);
  const [ok, setOk] = useState(false);
  const [already, setAlready] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setSending(true);
    try {
      const r = await axios.post(`${API}/newsletter/subscribe`, { email, name });
      setOk(true);
      setAlready(r.data?.already_subscribed);
      setEmail("");
      setName("");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Subscription failed");
    } finally { setSending(false); }
  };

  if (ok) {
    return (
      <div className="bg-emerald-600/10 border border-emerald-600/40 rounded-xl p-4 flex items-center gap-3"
           data-testid="newsletter-ok">
        <CheckCircle size={22} weight="duotone" className="text-emerald-400 shrink-0" />
        <div>
          <p className="text-sm font-heading font-semibold text-white">
            {already ? "You're already on the list" : "Subscribed"}
          </p>
          <p className="text-xs text-stone-400">
            {already ? "Look out for our next monthly update." : "Confirmation is not required. First email arrives at the start of the next cycle."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit}
      className={compact
        ? "flex flex-col sm:flex-row gap-2 items-stretch"
        : "space-y-3 bg-stone-900 rounded-2xl border border-stone-800 p-6"}
      data-testid="newsletter-form">
      {!compact && (
        <>
          <h3 className="font-heading text-lg font-semibold text-white flex items-center gap-2">
            <EnvelopeSimple size={18} weight="duotone" className="text-emerald-400" /> Subscribe
          </h3>
          <input value={name} onChange={(e) => setName(e.target.value)}
            placeholder="Your name (optional)" data-testid="newsletter-name"
            className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500" />
        </>
      )}
      <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com" data-testid="newsletter-email"
        className={compact
          ? "flex-1 bg-stone-900 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500"
          : "w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-emerald-500"} />
      <button type="submit" disabled={sending}
        className="bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white text-sm font-medium px-5 py-2.5 rounded-lg inline-flex items-center justify-center gap-2 shrink-0"
        data-testid="newsletter-submit">
        <EnvelopeSimple size={14} weight="bold" /> {sending ? "…" : "Subscribe"}
      </button>
      {err && <p className="text-xs text-red-400 sm:w-full" data-testid="newsletter-err">{err}</p>}
    </form>
  );
}
